<script setup lang="ts">
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'
import { PowerCredits } from '@/helpers/constants'

defineEmits(['close'])
defineProps<{ credits: number | null }>()
</script>

<template>
  <div class="gems-snackbar-fixed">
    <div class="gems-snackbar__content">
      <i
        class="mdi mdi-check-circle-outline"
        style="color: var(--palette-primary-main); margin-right: 1rem"
      />
      <span v-if="credits !== null">
        {{ credits.toLocaleString() }}&nbsp;{{ PowerCredits }}
        {{ $t('user_settings.credits_snackbar_added') }}
      </span>
      <GwBtn
        variant="btn_grey_white_primary"
        text="Close"
        style="
          margin-left: 1.5rem;
          border-radius: var(--radius-sm);
          --text-clr: var(--palette-text-secondary);
        "
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<style scoped>
.gems-snackbar-fixed {
  position: fixed;
  top: 4rem;
  right: 2rem;
  z-index: 999999999;
  background: var(--palette-paper-elevation4);
  border-radius: 12px;
  border: 1px solid rgba(168, 168, 177, 0.1);
  padding: 12px;
  display: flex;
  align-items: center;
  min-width: 350px;
}
.gems-snackbar__content {
  display: flex;
  align-items: center;
}
.gems-snackbar__content i {
  font-size: 24px;
}

@media (max-width: 768px) {
  .gems-snackbar-fixed {
    left: 50%;
    transform: translateX(-50%);
    min-width: 286px;
  }
  .gems-snackbar__content i {
    font-size: 20px;
    align-self: flex-start;
  }
}
</style>
